<template>
  <div id="wrap">
    <div id="header">
      <div id="stanfordLogo"></div>
    </div>
    <div id="content">
      <div id="score">
        <h1>{{ $store.getters['getUIText']('gameover') }}</h1>
        <h2>{{ score }}</h2>
        <div id="scoreSub">{{ $store.getters['getUIText']('score') }}</div>
      </div>
      <div id="submit">
        <header><img :src="doctor" alt=""> {{ $store.getters['getUIText']('thankyouforplaying') }}</header>
        <!--        <div id="submitContent">Thank you for playing!</div>-->
        <leaderboard></leaderboard>
        <button @click="showLogs = true">{{ $store.getters['getUIText']('viewactionlog') }}</button>
      </div>
      <div id="playAgain" @click="goHome">{{ $store.getters['getUIText']('playagain') }}</div>
    </div>
  </div>
  <div id="logWrap" v-if="showLogs" @click.self="showLogs = false">
    <div id="logContent">
      <div class="close" @click="showLogs = false">&times;</div>
      <div id="actionTableWrap">
        <h2>{{ $store.getters['getUIText']('actionstaken') }}</h2>
        <table id="ActionLog" class="recap-table">
          <thead>
          <tr>
            <th>{{ $store.getters['getUIText']('patient') }}</th>
            <th>{{ $store.getters['getUIText']('action') }}</th>
            <th>{{ $store.getters['getUIText']('health') }}</th>
            <th>{{ $store.getters['getUIText']('feedback') }}</th>
            <th>{{ $store.getters['getUIText']('score') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="action in actionLog" :key="action.action.timestamp">
            <td>{{ action.patient }}</td>
            <td>{{ action.action.name }}</td>
            <td>{{ Math.round(action.action.health) }}</td>
            <td>{{ action.action.tip && action.action.tip.response ? action.action.tip.response : "-" }}</td>
            <td>{{ action.action.tip && action.action.tip.score ? action.action.tip.score : "-" }}</td>
          </tr>
          </tbody>
        </table>
        <h2>{{ $store.getters['getUIText']('quizresults') }}</h2>
        <table id="QuizLog" class="recap-table">
          <thead>
          <tr>
            <th>{{ $store.getters['getUIText']('patient') }}</th>
            <th>{{ $store.getters['getUIText']('question') }}</th>
            <th>{{ $store.getters['getUIText']('youranswer') }}</th>
            <th>{{ $store.getters['getUIText']('response') }}</th>
            <th>{{ $store.getters['getUIText']('score') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(response, $index) in questionLog" :key="$index">
            <td>{{ response.name }}</td>
            <td>{{ response.question }}</td>
            <td>{{ response.answer }}</td>
            <td>{{ response.response }}</td>
            <td>{{ response.score }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="close-button"><button @click="showLogs = false">{{ $store.getters['getUIText']('closelog') }}</button></div>
    </div>
  </div>
</template>

<script>
import GameManager from "@/assets/js/GameManager";
import Leaderboard from "./leaderboard";
import API from "../assets/js/api";

export default {
  name: "EndScreen",
  components: {Leaderboard},
  data() {
    return {
      score: GameManager.score,
      doctor: "",
      patients: this.$store.getters["getCompletePatients"],
      showLogs: false
    }
  },
  computed: {
    actionLog() {
      let actionLog = [];
      let patients = this.$store.getters["getCompletePatients"];
      patients.forEach(patient => {
        patient.actions.forEach(action => {
          action.patient = patient.name;
          actionLog.push(action);
        })
        actionLog.push({
          patient: patient.name,
          action: {
            name: patient.endState.score < 0 ? "Patient died" : "Patient healed",
            health: patient.endState.score < 0 ? 0 : 300,
            tip: {
              response: patient.endState.response,
              score: patient.endState.score
            }
          }
        });
      })
      // actionLog.sort((a,b)=>{
      //   return a.timestamp > b.timestamp;
      // })
      return actionLog;
    },
    questionLog() {
      let questionLog = [];
      let patients = this.$store.getters["getCompletePatients"];
      patients.forEach(patient => {
        patient.quiz_responses.forEach(quiz => {
          quiz.name = patient.name;
        })
        questionLog.push(...patient.quiz_responses)
      })
      return questionLog;
    }
  },
  methods: {
    goHome() {
      this.$emit('showStart');
    }
  },
  mounted() {
    // name, loc, department, score, speed
    API.saveScore(this.$store.getters["user/full_name"], "-", "generic dept", GameManager.score, GameManager.game_speed);
  }
}
</script>

<style scoped lang="less">
@import (reference) "../assets/less/colors";
@media screen and (max-width: 774px){
  #stanfordLogo{
    margin: 0 auto;
  }
  #score{
    width: 320px;
    height: 320px;
    top: -15px;
  }
  #submit{
    margin: 0 0 1rem -245px;
  }
}
@media screen and (min-width: 775px){
  #stanfordLogo{
    margin-left: 40px;
  }
  #score{
    width: 475px;
    height: 475px;
    bottom: -50px;
  }
  #playAgain{
    position: absolute;
    bottom: -200px;
  }
  #submit{
    margin: 0 0 1rem -200px;
  }
}

#wrap {
  width: 100%;
  height: 100%;
  background: @darkgray;
  overflow: auto;
}

#content {
  height: 475px;
  width: 100%;
  background: @lightgray;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-wrap: wrap;
  position: relative;
  padding-top: 1.5rem;
}

#header {
  height: 60px;
  background-image: linear-gradient(to top, #5c0d1d 0%, #b01937 10px, @lightgray 10px, @lightgray 100%);
}

#stanfordLogo {
  height: 50px;
  width: 300px;
  background: url("../assets/images/Septris-sprite-start.png") -0px -3px;
}

#score {
  background: url("../assets/images/Septris-sprite-level-bg.png") top left no-repeat;
  background-size: contain;
  position: relative;
  max-width: 100%;
  max-height: 100%;
  text-align: right;
  color: white;
  font-family: monospace;
}

h1, h2, #scoreSub {
  position: absolute;
  right: 25%;
  font-weight: normal;
  margin: 0;
}

h1 {
  top: 30%;
  font-size: 2.25rem;
}

h2 {
  top: calc(30% + 3rem);
  font-size: 3rem;
}

#scoreSub {
  top: calc(30% + 6.5rem);
  font-size: 1.5rem;
}

#submit {
  background: @white;
  border: 4px solid @black;
  border-radius: 2rem;
  box-sizing: border-box;
  padding: 1rem 2rem 2rem 200px;
  height: 325px;
  width: 500px;
  font-size: 1.2rem;
  text-align: center;
}
#actionTableWrap{
  overflow: auto;
}
#playAgain {
  height: 185px;
  width: 185px;
  box-sizing: border-box;
  padding: 35px 37px 30px 25px;
  background: url("../assets/images/Septris-sprite-start.png") -30px -250px;
  color: @white;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 2rem;
  line-height: 1.3;
  font-family: Kalam, sans-serif;
  &:hover {
    background-position-x: -220px;
    cursor: pointer;
    text-shadow: 0 0 10px @white;
  }
}

.recap-table {
  border-collapse: collapse;
  line-height: 1.3;
  width: 100%;
  th {
    background: @black;
    color: @white;
    text-align: left;
    font-weight: 400;
  }

  th, td {
    border: 1px solid @black;
    padding: .3em .5em;
  }

  td {
    background: @white;
    max-width: 35em;
  }

  tr:nth-child(even) td {
    background: @lightgray;
  }

}

#logWrap {
  position: absolute;
  top: 0;
  z-index: 100;
  height: 100%;
  width: 100%;
  overflow: auto;
  background: rgba(0,0,0,0.3);
  h2{
    position: static;
    font-size: 1.5rem;
    margin: 1rem 0;
    font-weight: 700;
  }
  #logContent{
    background: @white;
    box-sizing: border-box;
    //width: 100%;
    max-width: 70em;
    margin: 0 auto;
    padding: 2em 1em;
    position: relative;
  }
}
.close{
  font-size: 2.2rem;
  font-weight: 700;
  position: absolute;
  top: 0.5rem;
  right: 1rem;
  cursor: pointer;
}
.close-button{
  padding: 1em;
  text-align: center;
  button{
    font-size: 1.4rem;
    padding: 0.4em 0.6em 0.45em;
    margin: 1.5em;
    background-image: linear-gradient(to bottom, lighten(@red, 10%), @red);
    color: @white;
    border: 0;
    border-radius: 0.2em;
    cursor: pointer;
  }
}
</style>
